import React, {useMemo, useContext, useCallback} from 'react';
import CodeLayout from './CodeLayout';
import {ChartingCodeContext} from '../lib/chartingCodeContext';
import {Box, Button, Dialog, Tab, Tabs} from '@mui/material';
import {grey} from '@mui/material/colors';
import {useSelector, useDispatch} from 'react-redux';
import {actions} from 'pages/Chart/Chart.redux';


const CodeLayoutTypeSelector = ({template}) => {
	const dispatch = useDispatch();
	const symbolID = useSelector(state => state.chart.symbolOptions.symbol);
	const {tab, setTab, requiredValuesFilled, handleSave} = useContext(ChartingCodeContext);

	const containerWidth = useMemo(() => {
		switch (template.layoutSize) {
			case 'sm':
				return 300;
			case 'md':
				return 500;
			case 'lg':
				return 700;
			default:
				return 300;
		}
	}, [ template.layoutSize ]);

	const point = useSelector(state => state.chart.symbolOptions.screenPoint);
	const windowWidth   = (typeof window !== 'undefined'
						   ? window.innerWidth
						   : 0),
		  windowHeight  = (typeof window !== 'undefined'
						   ? window.innerHeight
						   : 0),
		  left          = ((point?.[0] ?? 0) + containerWidth + 32) > windowWidth
						  ? windowWidth - 72 - containerWidth
						  : (point?.[0] ?? 0) - 200,
		  top           = ((point?.[1] ?? 0) + 700) > windowHeight
						  ? windowHeight - 800
						  : (point?.[1] ?? 0) - 50,
		  positionStyle = {
			  position: 'fixed' as const,
			  display: 'block',
			  opacity: 1,
			  zIndex: 100,
			  left,
			  top,
			  width: `${containerWidth}px`,
		  };

	const handleTabChange = (e, newTabValue) => {
		setTab(newTabValue);
	};

	const handleClose = useCallback(() => {
		dispatch(actions.resetSymbolOptions({symbol: symbolID}));
	}, [ symbolID, dispatch ]);


	if (tab !== null) {
		const tabs = template?.tabs ?? [];
		return (
			<Dialog
				open={true}
				onClose={handleClose}
				slotProps={{
					backdrop: {invisible: true},
					paper: {
						elevation: 12,
						style: positionStyle,
						sx: {padding: 2},
					},
				}}
			>
				<Box
					sx={{
						borderBottom: 1,
						borderColor: 'divider',
						marginBottom: 2,
						backgroundColor: grey[200],
					}}
				>

					<Tabs
						value={tab}
						onChange={handleTabChange}
						variant="scrollable"
						scrollButtons="auto"
					>
						{tabs.map(tab => (<Tab label={tab.label} key={tab.label} />))}
					</Tabs>

				</Box>

				<CodeLayout />

				<Box sx={{marginTop: 2}}>
					<Button
						variant="contained"
						disabled={!requiredValuesFilled}
						onClick={handleSave}
					>
						Save
					</Button>
					<Button
						sx={{marginLeft: 2}}
						onClick={handleClose}
						variant="outlined"
					>
						Cancel
					</Button>
				</Box>
			</Dialog>
		);
	}

	return (
		<Dialog
			open={true}
			onClose={handleClose}
			slotProps={{
				backdrop: {invisible: true},
				paper: {elevation: 12, style: positionStyle, sx: {padding: 2}},
			}}
		>
			<CodeLayout />

			<Box sx={{marginTop: 2}}>
				<Button
					variant="contained"
					disabled={!requiredValuesFilled}
					onClick={handleSave}
				>
					Save
				</Button>
				<Button
					sx={{marginLeft: 2}}
					onClick={handleClose}
					variant="outlined"
				>
					Cancel
				</Button>
			</Box>
		</Dialog>
	);
};

export default CodeLayoutTypeSelector;
